import http from '../api/http'

// 代理地址
let resquest = '/userApi'



//点击串联坝图层掉的解耦
export function getSmallCatchmentData(smallCatchmentCode) {
  return http.get(`${resquest}/ydb/series/info/query/catchment?smallCatchmentCode=${smallCatchmentCode}`)
}
export function getDzmData(date) {
  return http.get(`${resquest}/ydb/rainfall/dzmData?date=${date}`)
}

// 获取实时降雨或历史降雨下拉列表数据
export function getAlertTimeList(params) {
  return http.get(`${resquest}/ydb/warn/rainfall/getAlertTimeList`, params)
}

// 获取实时降雨告警数据
export function getAlertList(date) {
  return http.get(`${resquest}/ydb/warn/rainfall/getAlertList?date=${date}`)
}

export function getDzmTime() {
  return http.get(`${resquest}/ydb/rainfall/dzmTime`)
}


export function getDsManData(dsMan) {
  return http.get(`${resquest}/ydb/series/info/chartStats?dsMan=${dsMan}`)
}

//获取新建淤地坝数据
export function getNewDamData(params) {
  return http.post(`${resquest}/ydb/newDam/query`, params)
}

//获取新建淤地坝数据
export function getChartStatsData(params) {
  return http.post(`${resquest}/ydb/newDam/chartStats`, params)
}


//获取新建淤地坝数据
export function getQueryDamDisData(params) {
  return http.post(`${resquest}/cockpit/dis/queryDamDis`, params)
}

//获取单坝图表接口
export function getChartStatsSinData(params) {
  return http.post(`${resquest}/cockpit/dis/chartStatsSin`, params)
}

//获取单坝图表接口
export function getRainAndhydrologicalData(type) {
  return http.get(`${resquest}/rain/hy/rainandhydrological?type=${type}`)
}

//获取单坝图表接口
export function getSelectRainData(code) {
  return http.get(`${resquest}/rain/hy/selectonerainandhydrological?code=${code}`)
}
export function getPolygonHhlyData(params) {
  return http.post(`/prod-api/kpi/analysis/info/polygonHhly`, params)
  // return http.post(`http://123.52.64.242:20018/prod-api/kpi/analysis/info/polygonHhly`, params)
}

//根据雨量站、水文站编码获取对应的降雨信息
export function getInfoByCode(params) {
  return http.get(`${resquest}/rain/hy/getInfoByCode`,params)
}
//按行政区域、按风险等级、按类型划分、按一级支流统计、按下游有人、按是否病险坝、按接入监控、按有蓄水统计等详情信息
export function getoveralDetailRegion(params) {
  return http.post(`${resquest}/cockpit/ydb/overalDetailRegion`, params)
}
export function getoveralYdbDisClbDetail(params) {
  return http.post(`${resquest}/cockpit/ydb/overalYdbDisClbDetail`, params)
}
//水文气象图标接口
export function getselectanalysishydrologicstation(code) {
  return http.get(`${resquest}/rain/hy/selectanalysishydrologicstation?code=${code}`)
}
//雨量站雨量数据
export function getanalysisRainFall(code) {
  return http.get(`${resquest}/rain/hy/analysisRainFall?code=${code}`)
}
export function queryRainAndHydrological(params) {
  return http.get(`${resquest}/rain/hy/queryRainAndHydrological`,params)
}
